import {Component, OnInit,Inject} from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { OpdVisitService } from 'app/opdvisits/Services/OpdVisit.service';
import { DatePipe } from '@angular/common';
import { DashboardService } from 'app/dashboard/dashboard.service';
import { DialogData } from 'app/dashboard/remarks/remarks.component';
import { PatientDetailModel } from 'app/opdvisits/Models/patient_details.model';
import { AuthService } from 'app/auth/auth.service';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from 'app/shared/language.service';

@Component({
  selector: 'app-search-pt-dialog',
  templateUrl: './search-pt-dialog.component.html',
  styleUrls: ['./search-pt-dialog.component.scss']
})
export class SearchPtDialogComponent implements OnInit {
  showspinner = false;
  patientcount;
  dataSource = new MatTableDataSource<PatientDetailModel>();
  startdate;
  enddate;
  pname = "";
  constructor(
    public dialogRef: MatDialogRef<SearchPtDialogComponent>,
    public opdvisitService: OpdVisitService,
    public datepipe: DatePipe,
    public authService: AuthService,
    public dashboardService: DashboardService,
    public dialog: MatDialog,public translate: TranslateService,public langservice: LanguageService,
    @Inject(MAT_DIALOG_DATA) public data: DialogData) 
    {
     dialogRef.disableClose = true;
     translate.addLangs(['en', 'fr', 'hi']);
     if (this.langservice.setlang) {
       translate.setDefaultLang(this.langservice.setlang);
     }
     else {
       translate.setDefaultLang('en');
     }
    }

   //  displayedColumns: string[] = ['Patientid', 'Regdate', 'First_name', 'Last_name',
   //   'Care_of', 'Old_Mrno', 'Adhar_no', 'Address','Mothername','Email','dob','phno','mobno'];
   //  displayedColumns: string[] = ['Patientid', 'Regdate', 'First_name', 'Last_name',
    // 'dob','phno','mobno'];
    // DarSrNo
    // BookingBranch
    // BookingDate 
    // ApptDate
    // ApptTime
    // PatientId
    // PatientName
    // ContactNo
    // IsCancelled
    // ReferredBy
    // DoctorName

    //  displayedColumns: string[] = ['pkAppId','branchName', 'bookingDate', 'appDate',
    //  'appTime','patientId','patientName','contactNo','isCancelled','doctorName','referredBy','appType'];
    displayedColumns: string[] = ['Patientid', 'Regdate', 'First_name', 'Last_name',
    'dob','phno','mobno'];

     public branchId?: number;
     public branchName?: string;
     public bookingDate?: string;
     public appDate?: string;
     public appTime?: string;
     public doctorName?: string;
     public patientId?: number;
     public patientName?: string;
     public contactNo?: string;
     public isCancelled?: string;
     public referredBy?: string;
     public appType?: string;
     public appTakenBy?: string;
     public givenBy?: string;
     public modifyBy?: string;


   // displayedColumns: string[] = ['fkBranchId'];
    ngOnInit() {
      //console.log("usertype selected " + this.data.usertype);
      //this.checkusertype (this.data.usertype);
      //this.dataSource.data = this.opdvisitService.patients;
      this.patientcount = 0;
      
      this.getByDefaultList();
    }

    applyFilter(filterValue: string) {
      this.dataSource.filter = filterValue.trim().toLowerCase();
     
    }
    
 
  
   getByDefaultList(){
    this.dataSource.data = [];
     this.opdvisitService.get_top_200_patients().subscribe(data=>this.success_appt_sdate_edate(data), err=>this.failed_appt_sdate_edate)
   }
  
   gettop_200byname(pname: string){
    if(pname){
      this.showspinner = true;
      this.dataSource.data = [];

      this.opdvisitService.get_top200_byname(pname).subscribe(
        data => this.successtop200(data), err => this.failedtop200(err)
      )
} 
else{
  this.dashboardService.openSnackBar("Please Enter Name First", "Ok");
}

  
  }
  successtop200(data){
    this.showspinner = false;
    this.dataSource.data = [];
    this.dataSource.data = data;
   // alert("api working");
  }

  failedtop200(err){
    this.showspinner = false;
  }

     
    get_records_between_two_dates(){

     
      this.showspinner = true;
      this.dataSource.data = [];
     // this.dashboardService.selecteddate = this.datePipe.transform(selecteddate, "yyyy-MM-dd");
      let sdate = this.datepipe.transform(this.startdate, "yyyy-MM-dd");
      let edate = this.datepipe.transform(this.enddate, "yyyy-MM-dd");
//alert("st-" +this.startdate);
     this.opdvisitService.get_pat_sdate_edate(sdate,edate).
     subscribe(data => this.success_appt_sdate_edate(data), err => this.failed_appt_sdate_edate(err));
   }
 
   success_appt_sdate_edate(data){
    
   this.showspinner = false;
   this.patientcount = data.length;
   //this.opdvisitService.apptsearch = [];
   //this.opdvisitService.apptsearch = data;
   this.dataSource.data = data; //this.opdvisitService.apptsearch;
   //alert("Crossed");
   //console.log(data);

   }
 failed_appt_sdate_edate(err){
  this.showspinner = false;
 }


  onNoClick(): void {
    this.opdvisitService.WinsCount=0;
    this.dialogRef.close();
  }

 
selectpatient(selectedpatient: PatientDetailModel){
  
  //this.dialogRef.close();
 // console.log(selectedpatient);
 // alert("öm"+JSON.stringify(selectedpatient));
 //this.opdvisitService.apptdetail = selectedpatient;

//Assign values
this.opdvisitService.apptdetail = {};
   this.opdvisitService.apptdetail.initial = selectedpatient.initial.toString();
   if(selectedpatient.mobileNo!=null){
    this.opdvisitService.apptdetail.mobileNo= selectedpatient.mobileNo.toString();
   }else{
    this.opdvisitService.apptdetail.mobileNo=null;
   }
  
   this.opdvisitService.apptdetail.isVip = Boolean(selectedpatient.isvip);
   this.opdvisitService.states = [];
   this.opdvisitService.districts = [];
   this.opdvisitService.cities = [];
   this.opdvisitService.areas = [];
   if (selectedpatient.fkPcityId==null)
   {
     alert("City Not Found!");
     return;
   }
   this.opdvisitService.apptdetail.fkCityId = selectedpatient.fkPcityId;
   //alert(selectedpatient.fkPcityId);
   this.opdvisitService.apptdetail.fkConsultantId = this.opdvisitService.DoctorId;
   //this.opdvisitService.stateid = 0;
   //this.opdvisitService.districtid = 0;
   //this.opdvisitService.countryid = 0;
   this.opdvisitService.apptdetail.fkOccupationId = 0;
   this.opdvisitService.apptdetail.fkRefById = selectedpatient.fkReferredbyId;
   //alert("Intial City - "+selectedpatient.fkPcityId);
   this.opdvisitService.get_appt_city_district_state_country(selectedpatient.fkPcityId, 1);
  //this.opdvisitService.apptdetail.fkCityId=parseInt(this.patient_mendatory_fields[0].fK_CityId);
  //this.opdvisitService.apptdetail.initial="Mr."
  this.opdvisitService.apptdetail.fkApptTypeId=1;
  this.opdvisitService.apptdetail.fkRefById=1;
  this.opdvisitService.apptdetail.ageDays=0;
   this.opdvisitService.apptdetail.ageMonth =0;
   this.opdvisitService.apptdetail.ageYear =0;
   this.opdvisitService.apptdetail.fkServiceId = 0;
   this.opdvisitService.apptdetail.fkTakenOnId = 578;
   this.opdvisitService.apptdetail.isCancelled = null;
   this.opdvisitService.apptdetail.isSap = null;
   this.opdvisitService.apptdetail.lastName = selectedpatient.lastName;
   this.opdvisitService.apptdetail.firstName  = selectedpatient.firstName;
   this.opdvisitService.apptdetail.fkRegId  =selectedpatient.pkRegId;
   this.opdvisitService.apptdetail.pkAppointmentId  = null;
   //this.opdvisitService.apptdetail.sex=null;
   this.opdvisitService.apptdetail.address=selectedpatient.paddress;
   
   //
   this.opdvisitService.apptdetail.fkForBranchId=selectedpatient.fkBranchId;
   this.opdvisitService.apptdetail.daySrNo=null;
   this.opdvisitService.apptdetail.fkApptTypeId=1;
   this.opdvisitService.apptdetail.dob=selectedpatient.dob;
  if(selectedpatient.dob!=null)
  {
   this.getage(selectedpatient.dob);
  }
   this.opdvisitService.apptdetail.emailAddress=selectedpatient.emailAddress;
   this.opdvisitService.apptdetail.remarks=null;
   this.opdvisitService.apptdetail.isConfirm=null;
   this.opdvisitService.apptdetail.isCancelled=null;
   this.opdvisitService.apptdetail.tokenNo=null;
   this.opdvisitService.apptdetail.apptTime=this.opdvisitService.appservice.times; 

//
 this.opdvisitService.WinsCount=0;
 this.opdvisitService.is_nameEdit=true;
 this.opdvisitService.is_surNameEdit=true;
 
 this.dialogRef.close();

}
//Convert DOB
getage(selecteddate) {
  var oms=selecteddate.split("T");
  let container = oms[0].split("-");
  //let container = containerF.split("-");
  let selecteddate_converted = container[0] + "/" + container[1] + "/" + container[2];

  let currenttime = this.datepipe.transform(new Date(), "hh:mm:ss");
//  let dateofbirth = this.datePipe.transform(selecteddate, "yyyy-MM-dd");

let dateofbirth = this.datepipe.transform(selecteddate_converted, "yyyy-MM-dd");

  let currentdate = this.authService.getServerDate;

  this.getDataDiff(new Date(dateofbirth), new Date(currentdate));
  //console.log("difference" + diff);
}

getDataDiff(start, end) {


  let years: number = 0, months: number = 0, days: number;
  // Day diffence. Trick is to use setDate(0) to get the amount of days
  // from the previous month if the end day less than the start day.
  if (end.getDate() < start.getDate()) {
    months = -1;
    let datePtr: Date = new Date(end);
    datePtr.setDate(0);
    days = end.getDate() + (datePtr.getDate() - start.getDate());
  } else {
    days = end.getDate() - start.getDate();
  }

  if (end.getMonth() < start.getMonth() || (end.getMonth() === start.getMonth() && end.getDate() < start.getDate())) {
    years = -1;
    months += end.getMonth() + (12 - start.getMonth());
  } else {
    months += end.getMonth() - start.getMonth();
  }

  years += end.getFullYear() - start.getFullYear();
  
  this.opdvisitService.apptdetail.ageYear = years;
  this.opdvisitService.apptdetail.ageMonth = months;
  this.opdvisitService.apptdetail.ageDays = days;
 
}

clearfields() {

  // this.addresschecked = false;
   console.log("clear clicked");



   this.opdvisitService.apptdetail = {};
   this.opdvisitService.apptdetail.initial = '';

   this.opdvisitService.apptdetail.fkCityId = 0;
   this.opdvisitService.apptdetail.fkConsultantId = 0;
   this.opdvisitService.stateid = 0;
   this.opdvisitService.districtid = 0;
   this.opdvisitService.countryid = 0;
   this.opdvisitService.apptdetail.fkOccupationId = 0;
   this.opdvisitService.apptdetail.fkRefById = 0;
   this.opdvisitService.apptdetail.fkServiceId = 0;
   this.opdvisitService.apptdetail.fkTakenOnId = 0;
   this.opdvisitService.apptdetail.isCancelled = null;
   this.opdvisitService.apptdetail.isSap = null;
   this.opdvisitService.apptdetail.lastName = null;
   this.opdvisitService.apptdetail.firstName  = null;
   this.opdvisitService.apptdetail.fkRegId  = null;
   this.opdvisitService.apptdetail.pkAppointmentId  = null;
   this.opdvisitService.apptdetail.sex=null;
   this.opdvisitService.apptdetail.address=null;
   this.opdvisitService.apptdetail.ageDays=null;
   this.opdvisitService.apptdetail.ageMonth =null;
   this.opdvisitService.apptdetail.ageYear =null;
   //
   this.opdvisitService.apptdetail.fkForBranchId=null;
   this.opdvisitService.apptdetail.daySrNo=null;
   this.opdvisitService.apptdetail.fkApptTypeId=null;
   this.opdvisitService.apptdetail.dob=null;
   this.opdvisitService.apptdetail.emailAddress=null;
   this.opdvisitService.apptdetail.remarks=null;
   this.opdvisitService.apptdetail.isConfirm=null;
   this.opdvisitService.apptdetail.isCancelled=null;
   this.opdvisitService.apptdetail.tokenNo=null;
   this.opdvisitService.states = [];
   this.opdvisitService.districts = [];
   this.opdvisitService.cities = [];
   this.opdvisitService.areas = [];
   this.opdvisitService.apptdetail.apptTime=this.opdvisitService.appservice.times; 
 }

}
 


